module.exports = require("@adobe/aem-spa-page-model-manager");